export default __webpack_public_path__ + "static/media/upload-img.8c80680a.svg";